(function(){
    if (customElements.get('base-video-player') === undefined) {
        const template = document.createElement('template');
        template.innerHTML = `
        <style>
        :host {
            display: inline-block;
        }
        [part="wrapper"] {
            position: relative;
        }
        [part="background"] {
            position: relative;
            z-index: 0;
        }
        [part="click-target"] {
            position: absolute;
            z-index: 2;
            inset: 0;
        }
        [part="poster"] {
            position: absolute;
            z-index: 1;
            inset: 0;
        }
        :host([playing]) [part="poster"] {
            display: none!important;
        }
        [part="poster"] ::slotted(img) {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        [part="poster"]:empty {
            display: none;
        }
        :host([playing]) [part="click-target"] {
            pointer-events: none;
        }
        [part="play-button-container"] {
            left: 50%;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
            position: absolute;
            z-index: 1;
            transition:
                transform .5s ease,
                opacity .25s ease;
        }
        :host([playing]) [part="play-button-container"] {
            transform: translateY(-200%) translateX(-50%);
            opacity: 0;
        }
        [part="default-icon"] {
            border-radius: 100%;
            width: 48px;
            height: 48px;
            line-height: 48px;
            text-align: center;
            display: block;
            background: rgba(var(--color-main-rgb), 0.75);
            color: var(--color-back);
            transition: background .5s ease;
            &:hover {
                background: var(--color-main);
            }
        }
        [part="default-icon"]::before {
            content: "▶";
            font-family: 'Arial', sans-serif;
        }
        ::slotted(video) {
            display: block;
        }
        </style>
        <div part="wrapper">
            <div part="click-target">
                <span part="play-button-container">
                    <slot name="play-button">
                        <span part="default-icon"></span>
                    </slot>
                </span>
            </div>
            <div part="poster"><slot name="poster"></slot></div>
            <div part="background">
                <slot></slot>
            </div>
        </div>
        `;
        customElements.define('base-video-player', class extends HTMLElement {
            constructor() {
                super();
                this.attachShadow({mode: "open"}).appendChild(template.content.cloneNode(true));
            }
            get videoElement() {
                const defaultSlot = this.shadowRoot.querySelector('slot:not([name])');
                const children = defaultSlot.assignedElements({flatten: true});
                for (const child of children) {
                    if (child instanceof HTMLVideoElement) {
                        return child;
                    }
                    if (typeof child.play === "function" && typeof child.pause === "function") {
                        // already defined video component
                        return child;
                    }
                    if (!child.matches(':defined') && child.tagName.toLowerCase().indexOf('video') > -1) {
                        // this must be a video component that is not defined yet, we simply assume this is going to happen
                        return child;
                    }
                }
                return null;
            }
            connectedCallback() {
                if (this.hasAttribute('playing')) {
                    this.removeAttribute('playing');
                }
                this.connectVideo();
                this.addEventListener('slotchange', () => {
                    this.connectVideo();
                });
                this.shadowRoot.querySelector('[part="click-target"]').addEventListener('click', this.handleClickEvent.bind(this));
            }

            connectVideo() {
                const video = this.videoElement;
                if (!video) {
                    return;
                }
                if ((video['baseVideoPlayer'] ?? null) === this) {
                    return;
                }
                video.addEventListener('play', () => {
                    if (this.getAttribute('playing') !== 'playing') {
                        this.setAttribute('playing', 'playing');
                    }
                });
                video.addEventListener('pause', () => {
                    if (this.getAttribute('playing')) {
                        this.removeAttribute('playing');
                    }
                });
                if (video instanceof HTMLVideoElement) {
                    video.controls = false;
                    video.addEventListener('play', () => {
                        video.controls = true;
                    });
                    video.addEventListener('pause', () => {
                        if (!this.matches(':focus-within')) {
                            video.controls = false;
                        }
                    });
                    this.addEventListener('focusin', () => {
                        video.controls = true;
                    })
                    this.addEventListener('focusout', () => {
                        if (!this.matches(':focus-within')) {
                            video.controls = false;
                        }
                    });
                }
            }

            handleClickEvent(event) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                if (this.hasAttribute('playing')) {
                    this.pause();
                } else {
                    this.play();
                }
            }
            play() {
                const video = this.videoElement;
                if (video) {
                    video.play();
                }
                this.setAttribute('playing', 'playing');
            }
            pause() {
                const video = this.videoElement;
                if (video) {
                    video.pause();
                }
                this.removeAttribute('playing');
            }
        });
    }
})();
